export const protectedRoutes = [
  '/publish',
  '/publish-new',
  '/update',
  '/dashboard/',
  '/order/',
  '/unsubscribe/',
];

export function isProtectedRoute(path: string) {
  for (const route of protectedRoutes) {
    if (path.startsWith(route)) {
      return true;
    }
  }

  return false;
}
